import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import Footer from "../components/Footer";
import Container from "../components/Container";

const ManagerialPosition = () => {
  const positions = [
    {
      m: 1,
      name: "	عبدالواحد محمد آل يوسف",
      post: "المدير التنفيذي ",
      phone: "0138561062",
    },
    {
      m: 2,
      name: "",
      post: "مدير إدارة البرامج التنموية",
      phone: "0138561062",
    },
    {
      m: 3,
      name: "حبيب حسن محيف",
      post: "مدير إدارة الجودة",
      phone: "0138561062",
    },
    { m: 4, name: "", post: "منسق التحول الرقمي", phone: "0138561062" },
    {
      m: 5,
      name: "إيمان مهدي السويدان",
      post: "مدير الاتصال المؤسسي والتسويق",
      phone: "0138561062",
    },
    {
      m: 6,
      name: "",
      post: "مدير إدارة الموارد المالية والشراكات",
      phone: "0138561062",
    },
    {
      m: 7,
      name: "حسن علي سهو",
      post: "مدير إدرة خدمات المستفيدين",
      phone: "0138561062",
    },
    {
      m: 8,
      name: "عبدالمحسن حسين السلطان",
      post: "مدير فرع المحمدية بالدمام",
      phone: "0138383855",
    },
    {
      m: 9,
      name: "علي ناصر البوعيسى",
      post: "	نائب مدير فرع المحمدية بالدمام",
      phone: "0138383855",
    },
    {
      m: 10,
      name: "عبدالرؤوف عبدالجليل الرميح",
      post: "مدير إدارة العمل التطوعي",
      phone: "0138561062",
    },
    {
      m: 11,
      name: "جعفر علي آل شويخ",
      post: "مدير الشؤون الإدارية والمالية",
      phone: "0138561062 تحويلة 600",
    },
    {
      m: 12,
      name: "محمد سعود العيد",
      post: "	مدير فرع عنك",
      phone: "0503400850",
    },
  ];

  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <Container>
        <div className="py-12 md:py-16 lg:py-24">
          <h1 className="font-bold text-lg md:text-xl lg:text-2xl mb-8 md:mb-12 text-[#21497C] text-center">
            المناصب الإدارية
          </h1>
          <div>
            <div className="relative overflow-x-auto">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-base text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      م
                    </th>
                    <th scope="col" className="px-6 py-3">
                      الاسم
                    </th>
                    <th scope="col" className="px-6 py-3">
                      المنصب
                    </th>
                    <th scope="col" className="px-6 py-3">
                      الهاتف
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {positions.map(({ m, name, post, phone }) => {
                    return (
                      <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          {m}
                        </th>
                        <td className="px-6 py-4">{name}</td>
                        <td className="px-6 py-4">{post}</td>
                        <td className="px-6 py-4">{phone}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default ManagerialPosition;
